<template>
  <VWidget
    :title="$t('Related Products and Taxonomy')"
  >
    <div slot="widget-content">
      <v-expansion-panel expand>
        <v-expansion-panel-content>
          <template v-slot:header>
            <span class="subheading">{{ $t('Related Products') }} ({{ product.related.products.length || 0 }})</span>
          </template>

          <v-divider/>

          <product-single-related-products :product="product"/>
        </v-expansion-panel-content>

        <v-expansion-panel-content>
          <template v-slot:header>
            <span class="subheading">{{ $t('Related Taxonomy') }} ({{ product.related.taxonomy.length || 0 }})</span>
          </template>

          <v-divider/>

          <product-single-related-taxonomy :product="product"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </VWidget>
</template>

<script>
import ProductSingleRelatedProducts
  from '@/modules/Products/components/ProductSingle/Related/ProductSingleRelatedProducts'
import ProductSingleRelatedTaxonomy
  from '@/modules/Products/components/ProductSingle/Related/ProductSingleRelatedTaxonomy'

export default {
  name: 'ProductSingleRelated',
  components: {
    ProductSingleRelatedTaxonomy,
    ProductSingleRelatedProducts
  },

  props: {
    product: {
      required: true,
      type: Object
    }
  }
}
</script>
